import { CallOutDetailContext, CategoryTabInfo, OBCategoryTab } from '@pulseops/outbound'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, Text, View } from 'react-native'
import { OBPolicyTab } from './OBPolicyTab'
import { OBInvestmentTab } from './ob-investment-tab/OBInvestmentTab'
import { useIsFocused } from '@react-navigation/native'
import { ProductTypeC } from '@pulseops/inbound'
import { isNil } from 'lodash'

export const OBRMDSpecialInformation = () => {
  const { t, i18n } = useTranslation()
  const [categoryTabIndex, setCategoryTabIndex] = React.useState(0)
  const [categoryTabList, setCategoryTabList] = React.useState<CategoryTabInfo[]>([])
  const [productInfo, setProductInfo] = React.useState<ProductTypeC>()
  const { permissions, policyNumber } = React.useContext(CallOutDetailContext)
  const isFocused = useIsFocused()

  React.useEffect(() => {
    if (isFocused) {
      setCategoryTabIndex(0)
    } else {
      setProductInfo(undefined)
    }
  }, [isFocused])

  const checkTabViewPermission = () => {
    const listTabPermission: CategoryTabInfo[] = []
    listTabPermission.push({
      label: t('Outbound:OBSpecialInfo:Policy'),
      key: '1'
    })
    if (!isNil(productInfo) && ['ULP', 'ILP'].includes(productInfo?.body.productType as string)) {
      listTabPermission.push({
        label: t('Outbound:OBSpecialInfo:Investment'),
        key: '2'
      })
    }

    setCategoryTabList(listTabPermission)
  }

  React.useEffect(() => {
    checkTabViewPermission()
  }, [permissions, i18n.language, productInfo])

  const getComponentByTabIndex = () => {
    const tabIndx = categoryTabIndex + 1
    switch (tabIndx) {
      case 1:
        return <OBPolicyTab setProductInfo={setProductInfo}></OBPolicyTab>
      case 2:
        return <OBInvestmentTab productInfo={productInfo} />
      default:
        return <></>
    }
  }

  return (
    <View style={specialStyles.container}>
      <OBCategoryTab
        dataSource={categoryTabList}
        onChangeTab={(index) => {
          setCategoryTabIndex(index)
          // setTabIndex(categoryTabList[index])
        }}
        activeTabIndex={categoryTabIndex}
      ></OBCategoryTab>
      {isFocused ? getComponentByTabIndex() : <></>}
    </View>
  )
}
const specialStyles = StyleSheet.create({
  container: {
    marginTop: 24
  }
})
